import React from "react";
import { Button, Col, Row } from "reactstrap";

const ExportedRequests = () => {
  return (
    <div className="page-content px-4 pb-0">
      <Row>
        <Col md={12} className="m-auto">
          <div
            style={{ backdropFilter: " blur(4px)" }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">Exported Requests</h4>
          </div>

          <div className="table-responsive position-relative d-flex flex-column mt-3">
            <table className="table table-nowrap table-centered align-middle mb-0">
              <thead className="bg-light text-mute fs-14">
                <tr>
                  <th></th>
                  <th>Requested on</th>
                  <th>Requested By</th>
                  <th>Report type</th>
                  <th>Expiry</th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="fs-13">
                <tr>
                  <td className="text-center">1</td>
                  <td>
                    <p className="mb-0">18 November 2024</p>
                    <span className="fs-10 text-muted">11:31 AM</span>
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="flex-shrink-0">
                        <img
                          src="https://themesbrand.com/velzon/html/master/assets/images/users/avatar-1.jpg"
                          alt=""
                          className="avatar-xs rounded-circle"
                        />
                      </div>
                      <div>
                        <p className="mb-0">Abdul Bari</p>
                        <span className="fs-10 text-muted">
                          abdul.bari@danubehome.com
                        </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p className="mb-0">Other Reports</p>
                    <span className="fs-10 text-muted">
                      2024-09-01 - 2024-11-18
                    </span>
                  </td>
                  <td>
                    <p className="mb-0">25 November 2024</p>
                    <span className="fs-10 text-muted">11:31 AM</span>
                  </td>
                  <td className="text-center">
                    <Button
                      type="button"
                      className="badge btn btn-success py-2"
                    >
                      <i className="ri-download-2-line fs-18"></i>
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ExportedRequests;
